import React, { Component } from "react"
import AdminDashBillingSettings from "./admin_dash_billing_settings"
import { SettingsFormField } from "./settings/settings_form_field"
import { SettingsSection } from "./settings/settings_section"

const billingStrings = {
    sectionTitle: "Company",
    sectionDetail: "Displayed in reports, emails, and other places",
    companyName: "Company Name",
}

const { sectionTitle, sectionDetail, companyName } = billingStrings

class BillingSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            companyName: "",
            saveCompanyNameEnabled: false,
        }
    }

    updateFormField = (value, key) => {
        this.setState({ [key]: value }, () => {
            const newState = {
                ...this.state,
                [key]: value,
            }
            // validation
            if (key === "companyName") {
                const shouldEnable = !!newState.companyName
                this.setState({ saveCompanyNameEnabled: shouldEnable })
            }
        })
    }

    saveCompanyName = () => {
        const { saveCompanyNameEnabled, companyName } = this.state

        saveCompanyNameEnabled && this.props.updateAccountName(companyName)
    }

    componentDidUpdate(prevProps) {
        // receive changes to account name
        const { profile } = this.props
        const { accountId } = profile
        const { name } = this.props.accounts.items[accountId]
        const prevName = prevProps.accounts.items[accountId].name

        if (prevName !== name) {
            this.setState({
                companyName: name,
                saveCompanyNameEnabled: false,
            })
        }
    }

    componentDidMount() {
        const { accounts, profile } = this.props
        const { accountId } = profile

        if (accounts.items[accountId].name) {
            const { name } = accounts.items[accountId]
            this.setState({ companyName: name })
        }
    }

    render() {
        const {
            selectedTeamInvites,
            customer,
            setPaymentModalOpen,
            handleCancelPlan,
            profile,
        } = this.props
        return (
            <div className="profile-settings">
                <SettingsSection
                    sectionTitle={sectionTitle}
                    details={sectionDetail}
                    isDisabled={!this.state.saveCompanyNameEnabled}
                    saveAction={this.saveCompanyName}
                >
                    <div className="section-column">
                        <SettingsFormField
                            focus={true}
                            className=""
                            id={"companyName"}
                            label={companyName}
                            value={this.state.companyName}
                            onChangeAction={this.updateFormField}
                        />
                    </div>
                </SettingsSection>
                <AdminDashBillingSettings
                    teamMembers={profile.teamMembers}
                    selectedTeamInvites={selectedTeamInvites}
                    customer={customer}
                    setPaymentModalOpen={setPaymentModalOpen}
                    handleCancelPlan={handleCancelPlan}
                />
            </div>
        )
    }
}

export default BillingSettings



// WEBPACK FOOTER //
// ./src/components/billing_settings.jsx